export default __webpack_public_path__ + "static/media/HeroVector.2fafd841.svg";